import getMaxValueByPaymentType from '@/commons/services/getMaxValueByPaymentType';

const getMaxValue = type => getMaxValueByPaymentType.get(type);

export default {
  getMaxValue
};
